module.exports = __webpack_public_path__ + "img/curved-arrow.5e53a033.png";